class r extends Error{constructor(r){super(r)}}export{r as default};
//# sourceMappingURL=CancelError.js.map
